module.exports = __webpack_public_path__ + "static/img/yueYueShangXin.d3fb61a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yueYueShangXin.jpg
// module id = L7vv
// module chunks = 2